module.exports = __webpack_public_path__ + "static/heise-b1b32d2a0f5f9ec92474cc554292438a.png";